import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { editProductionTarget } from 'services/api/requests/production-target';
import { mapErrorToToastProps } from 'utils/forms/mapErrorToToastProps';

export const useEditProductionTarget = (body, setCloseSave, reloadData) => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return useMutation(() => editProductionTarget(body), {
		onSuccess: () => {
			queryClient.invalidateQueries(['production-target-list']);
			setCloseSave(false);
			reloadData();
			toast({
				title: 'Atualizado com sucesso!',
				description: 'Metas de produção atualizada com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});
		},
		onError: (error: any) => {
			// error?.response?.data?.message[0]?.constraints?.isNotEmpty,
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao atualizar as metas de produção!'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
